<template>
  <div>
    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push({name: 'importation-new'}).catch((err) => {})">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Novo</span>
      </div>
    </div>
    <vue-good-table
      style="width: 100%;"
      :rows="getImportations"
      :columns="columns"
      :pagination-options="paginationOptions"
      :search-options="{
      enabled: true,
      trigger: 'enter',
      placeholder: 'Procurar',
    }"
      styleClass="vgt-table condensed">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>
      <template slot="table-row" slot-scope="importation">
        <span class="font-medium" v-if="importation.column.field == 'codigo'">
          {{importation.row.numeroImportacao}} | {{importation.row.codigoInvoice}}
        </span>
        <span class="font-medium" v-else-if="importation.column.field == 'ações'">
          <div>
            <feather-icon
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="$router.push(`/importacoes/editar/${importation.row.idImportacao}`)" />
            <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" />
            <vs-dropdown class="cursor-pointer" vs-trigger-click>
              <a class="flex items-center" style="font-weight: 500; font-size: 1rem" href="#">
                Mais
                <i class="material-icons"> expand_more </i>
              </a>
              <vs-dropdown-menu class="w-48">
                <vs-dropdown-item @click="generateInvoice(importation.row.idImportacao, 'pdf')">
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Invoice - PDF
                </vs-dropdown-item>
                <vs-dropdown-item @click="generateInvoice(importation.row.idImportacao, 'xlsx')">
                  <font-awesome-icon :icon="['far', 'file-excel']" class="w-4" />
                  Invoice - Excel
                </vs-dropdown-item>
                <vs-dropdown-item @click="generatePackingList(importation.row.idImportacao)">
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Packing List
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Invoice c/ Peso Bruto.
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Personalizado
                  <!--  pegar do banco -->
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Descrição
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <font-awesome-icon :icon="['far', 'file-pdf']" class="w-4" />
                  Comissão
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <font-awesome-icon :icon="['fas', 'shipping-fast']" class="w-4" />
                  Frete
                </vs-dropdown-item>
                <vs-dropdown-item>
                  <font-awesome-icon :icon="['fas', 'dollar-sign']" class="w-4" />
                  Pagamento
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </span>
        <span class="font-medium" v-else>
          {{ importation.formattedRow[importation.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <InvoicePdf ref="invoicePdf"></InvoicePdf>
    <InvoiceXlsx ref="invoiceXlsx"></InvoiceXlsx>
    <PackingListPdf ref="packingListPdf"></PackingListPdf>
  </div>
</template>
<script>
import helpers from "@/helpers";
import InvoicePdf from "./reports/InvoicePdf.vue"
import InvoiceXlsx from "./reports/InvoiceXlsx.vue"
import PackingListPdf from "./reports/PackingListPdf.vue"

export default {
  data() {
    return {
      importations: [],
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    }
  },
  components: {
    InvoicePdf,
    InvoiceXlsx,
    PackingListPdf,
  },
  computed: {
    getImportations() {
      return this.$store.state.importations
    },
  },
  methods: {
    async generateInvoice(idImportation, format) {
      if (format == 'pdf')
        await this.$refs.invoicePdf.generate(idImportation)
      else if (format == 'xlsx')
        await this.$refs.invoiceXlsx.generate(idImportation)
    },
    async generatePackingList(idImportation) {
      await this.$refs.packingListPdf.generate(idImportation)
    },
    mountTable() {
      this.columns = [{
          label: 'N° | Código',
          field: 'codigo'
        },
        {
          label: 'Criado Por',
          field: 'nome'
        },
        {
          label: 'Criado Em',
          field: 'criado_em',
          formatFn: this.helpers.dateHelper.formatDateTimeToPTBR
        },
        {
          label: 'Última Modificação',
          field: 'ultima_modificacao',
          formatFn: this.helpers.dateHelper.formatDateTimeToPTBR
        },
        {
          label: 'Data do Pedido',
          field: 'data_pedido',
          formatFn: this.helpers.dateHelper.formatDateToPTBR
        },
        {
          label: 'Data do Envio',
          field: 'data_envio',
          formatFn: this.helpers.dateHelper.formatDateToPTBR
        },
        {
          label: 'Ações',
          field: 'ações',
          sortable: false
        }
      ]
    }
  },
  async created() {
    this.helpers = helpers
    let payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchImportationsItems", payload)
    this.mountTable()
    // this.getAllLabelFilters()
  },
}

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
